import { RefObject, useEffect, useRef, useState } from 'react';

import { faVolumeUp, faVolumeMute } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import MediaMethods from '../mediaDataCollector/MediaMethods';

interface VolumeButtonProps {
  playerRef: RefObject<HTMLAudioElement> | RefObject<HTMLVideoElement> | RefObject<any>;
}

function VolumeButton({ playerRef }: VolumeButtonProps) {
  const [isMuted, setIsMuted] = useState<boolean>(true);
  const volumeBarRef = useRef<HTMLInputElement>(null);

  function updatePlayerVolumeFromVolumeBar() {
    MediaMethods.setVolume(playerRef, volumeBarRef.current!.value);

    volumeBarRef.current!.style.setProperty(
      '--seeker-width',
      `${(parseInt(volumeBarRef.current!.value) / parseInt(volumeBarRef.current!.max)) * 100}%`
    );
  }

  function toggleMute() {
    if (isMuted) MediaMethods.mute(playerRef);
    else MediaMethods.unMute(playerRef);
    setIsMuted(!isMuted);
  }

  useEffect(() => {
    volumeBarRef.current!.style.setProperty(
      '--seeker-width',
      `${(parseInt(volumeBarRef.current!.value) / parseInt(volumeBarRef.current!.max)) * 100}%`
    );
  }, []);

  return (
    <span className="media-player-inner-container media-player-button-volume">
      <button className="media-player-button " onClick={toggleMute} type="button">
        <FontAwesomeIcon className="media-player-icon" icon={isMuted ? faVolumeUp : faVolumeMute} />
      </button>
      <div className="media-player-bar-volume">
        <input
          ref={volumeBarRef}
          className="progress-bar"
          type="range"
          defaultValue={100}
          max={100}
          onChange={updatePlayerVolumeFromVolumeBar}
        />
      </div>
    </span>
  );
}

export default VolumeButton;
